// Play locales whose script is right-to-left. Match on the primary subtag so
// every region variant (ar, ar-EG, he-IL, fa, ur-PK) is covered.
const RTL_PRIMARY = new Set(['ar', 'he', 'fa', 'ur']);

export function isRtlLocale(code: string): boolean {
  const primary = code.split('-')[0]?.toLowerCase();
  return !!primary && RTL_PRIMARY.has(primary);
}
